import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'
import globalTheme from '../../styles/theme'
import { DolaThemes } from '../../styles/types'
import { borderRadius, borderWidth, fontSize } from '../../styles/variables'
import buttonTheme from '../Button/styles/theme'

export const Wrapper = styled.div`
  position: relative;
`

interface SuggestionWrapperProps {
  dolaTheme: DolaThemes
}

export const SuggestionWrapper = styled.div<SuggestionWrapperProps>`
  background: ${({ dolaTheme }) => buttonTheme[dolaTheme].secondary.border};
  position: absolute;
  width: 100%;
  top: 3.5vw;
  left: -0.3vw;
  z-index: 2;
  ${borderRadius};

  ${iPadDown} {
    top: 10.82vw;
    left: -0.93vw;
  }
`

interface SuggestionContentProps {
  dolaTheme: DolaThemes
}

export const SuggestionContent = styled.div<SuggestionContentProps>`
  background: ${({ dolaTheme }) => globalTheme[dolaTheme].background};
  border-style: solid;
  border-color: ${({ dolaTheme }) => buttonTheme[dolaTheme].secondary.border};
  position: relative;
  transform: translate(0.3vw, -0.3vw);
  ${borderRadius};
  ${borderWidth};

  ${iPadDown} {
    transform: translate(0.93vw, -0.93vw);
  }
`

interface SuggestionItemProps {
  dolaTheme: DolaThemes
}

export const SuggestionItem = styled.div<SuggestionItemProps>`
  min-height: 3.13vw;
  display: flex;

  ${iPadDown} {
    min-height: 9.7vw;
  }

  > span {
    flex-grow: 1;
  }
  p {
    align-items: center;
    display: flex;
    padding: 0 1.33vw;
    ${fontSize}

    ${iPadDown} {
      padding: 0 4.59vw;
    }
  }
  &:not(:last-child) {
    border-bottom: 1px solid
      ${({ dolaTheme }) => globalTheme[dolaTheme].border};
  }
`
